var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showLayer,
      expression: "showLayer"
    }],
    staticClass: "y-layer",
    class: _vm.extraClass
  }, [_c('transition', {
    attrs: {
      "name": "y-layer__mask"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMask,
      expression: "showMask"
    }],
    staticClass: "y-layer__mask",
    on: {
      "click": function click($event) {
        return _vm.closeDialog('maksClose');
      }
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showPanel,
      expression: "showPanel"
    }],
    staticClass: "y-layer__panel",
    class: ['animate' + _vm.animateType, _vm.animateClass]
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showClose,
      expression: "showClose"
    }],
    staticClass: "y-layer__close",
    class: _vm.extraCloseClass,
    on: {
      "click": _vm.closeDialog
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showHeader,
      expression: "showHeader"
    }],
    staticClass: "y-layer__header",
    class: [_vm.extraHeaderClass, _vm.hasBottomLine ? 'bottom-line' : '']
  }, [_vm._t("header")], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showBody,
      expression: "showBody"
    }],
    staticClass: "y-layer__body",
    class: _vm.extraBodyClass
  }, [_vm._t("body")], 2), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFooter,
      expression: "showFooter"
    }],
    staticClass: "y-layer__footer",
    class: _vm.extraFooterClass
  }, [_vm._t("footer")], 2)])], 1), _c('transition', {
    attrs: {
      "name": "y-layer__toast"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showToastBox,
      expression: "showToastBox"
    }],
    staticClass: "y-layer__toast"
  }, [_vm._t("toast")], 2)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };